import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';

import ButtonDisclosures from '../../../atoms/button-disclosures';
import CardModule from '../../shared/card-module';
import format from '../../../../utils/format';
import styles from './fees-and-expenses-expense-charge.module.scss';
import { augment } from '../../../../utils/GlobalCssProxy';
import { className } from '../../../../utils/GlobalCssProxy';

const s = augment(styles);

const FeesAndExpensesExpenseCharge = ({ expenses, heading, isHideForPrint }) => {
  return (
    <CardModule
      data-analytics-componenttype="third-width-component"
      data-analytics-id="TW_FeesAndExpensesExpenseCharge"
      data-analytics-section="component"
      {...className(isHideForPrint ? 'd-print-none' : '')}
    >
      <CardModule.Header>{heading}</CardModule.Header>
      <CardModule.Body>
        <Row as="dl">
          <Col
            as="dt"
            xs={6}
            md={12}
            lg={6}
            className={s(
              'align-self-end',
              'font-weight-normal',
              'd-flex',
              'justify-content-start',
              'label'
            )}
          >
            <span className={s('sub-info')}>
              Estimated Expense Charge
            </span>

          </Col>
          <Col
            as="dd"
            xs={6}
            md={12}
            lg={6}
            className={s(
              'd-flex',
              'font-family-agenda',
              'justify-content-start',
              'mb-0',
              'percentage',
              'text-nowrap',
              'text-secondary'
            )}
          >
            {format.percent(expenses.grossExpenseRatio)}
          </Col>
        </Row>
      </CardModule.Body>
      <CardModule.Footer className={s('text-right')}>
        {/*Fees and expenses and performance returns use the same disclosure terms*/}
        <ButtonDisclosures module={'performance-returns'} />
      </CardModule.Footer>
    </CardModule>
  );
};

FeesAndExpensesExpenseCharge.defaultProps = {
  expenses: {},
  heading: 'Fees & Expenses'
};

FeesAndExpensesExpenseCharge.propTypes = {
  expenses: PropTypes.shape({
    netExpenseRatio: PropTypes.number,
    grossExpenseRatio: PropTypes.number,
    estAnnualExpenses: PropTypes.number
  }),
  heading: PropTypes.string,
  isHideForPrint: PropTypes.bool
};

export default FeesAndExpensesExpenseCharge;
